import { PropsWithChildren } from 'react';

export interface IProgressBarProps {
  totalSize: number;
  finished: number;
  hidePercentage?: boolean;
  height?: string | number;
}

export function ProgressBar(props: PropsWithChildren<IProgressBarProps>) {
  const completed = Math.round((props.finished / props.totalSize) * 100);
  const totalPercentage = `${completed}%`;
  return (
    <div className="dp-progress-bar__root">
      <div className="dp-progress-bar" style={{ height: props.height }}>
        <div className="dp-progress-bar--completed full-size" style={{ width: `${totalPercentage}` }}></div>
      </div>
      {!props.hidePercentage && (
        <div className="dp-progress-bar__info">
          {props.children}
          <span className="dp-progress-bar__percentage">{totalPercentage}</span>
        </div>
      )}
    </div>
  );
}
